/**
 * @description upload video model
 * @date 2019-04-08
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import Arr from '@util/array';
import './index.scss';
@inject('store')
@observer
class Upload extends React.Component<any, any> {
    public $inputFile: HTMLInputElement;
    constructor(props) {
        super(props);
    }
    public render() {
        return (
            <div className="upload-video-box">
                <span className="iconfont">&#xe6da;</span>
                <div className="button-file-box">
                    <Button onClick={this.ButtonClick} type="primary">上传视频</Button>
                </div>
                <p>单个文件不超过4G|建议分辨率为1080P（1920*1080)及以上
                支持常用视频格式，推荐使用mp4、mov</p>
            </div>
        );
    }
    public ButtonClick = () => {
        const fileInput = this.props.fileInput || document.querySelectorAll('.uploadVideoInput')[0];
        fileInput.click();
    }
}
export default Upload;
